import useAxios from 'axios-hooks'
import { useContext, useEffect } from 'react'
import { ProcessesContext } from '~/contexts/ProcessesContext'

const THREE_SECONDS_IN_MS = 3 * 1000
const ONE_MINUTE_IN_MS = 60 * 1000

export default () => {
  const { setProcesses, setStatus, processRetry } = useContext(ProcessesContext)
  const [, fetchProcesses] = useAxios(
    {
      method: 'GET',
    },
    { manual: true }
  )

  useEffect(() => {
    const session = localStorage.getItem('persist:locasty')
    const parsedSession = JSON.parse(session, (key, value) => {
      try {
        return JSON.parse(value)
      } catch {
        return value
      }
    })
    if (!parsedSession?.auth?.refresh_token) return

    let timeoutId
    let isMounted = true
    const userId = parsedSession.user?.profile?.id

    const fetchData = async () => {
      const res = await fetchProcesses({
        url: `/users/${userId}/processes`,
      })
      const { data } = res

      if (!data) {
        if (isMounted) {
          setProcesses([])
          setStatus('NONE')
        }
        return
      }

      const processRunning = data?.some(
        process => process.status === 'RUNNING' || process.status === 'QUEUED'
      )

      if (isMounted) {
        const status = data?.some(
          process => process.status === 'RUNNING' || process.status === 'QUEUED'
        )
          ? 'RUNNING'
          : data?.some(
              process =>
                process.status === 'FAILED' || process.status === 'PARTIAL'
            )
          ? 'PARTIAL'
          : 'NONE'
        setProcesses(data)
        setStatus(status)
      }

      if (isMounted) {
        timeoutId = setTimeout(
          fetchData,
          processRunning ? THREE_SECONDS_IN_MS : ONE_MINUTE_IN_MS
        )
      }
    }

    fetchData()

    return () => {
      clearTimeout(timeoutId)
      isMounted = false
    }
  }, [processRetry])

  return null
}
